import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import SearchInput from "../../test/components/SearchInput";
import TestItemsSlider from "../../test/components/TestItemsSlider";
import TestItemOngoing from "../../test/components/TestItemOngoing";
import {fetchTests, fetchTestsEnCurso} from "../../../redux/actions/sagaActions";
import TestItem from "../../test/components/TestItem";
import TestsList from "../../test/components/TestsList";
import TestsOngoingLists from "../../test/components/TestsOngoingLists";
import CircularProgress from "@material-ui/core/CircularProgress";
import Invitations from "./Invitations";
import EnCursoInvs from "./EnCursoInvs";

function TabContainer({ children, dir, padding }) {
  if (typeof padding === "undefined") {
    padding = 10;
  }
  return (
    <Typography component="div" dir={dir} style={{ padding: padding }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    [theme.breakpoints.up("md")]: {
      padding: "64px"
    }
  },
  appBar: {
    backgroundColor: "initial",
    boxShadow: "none",
    borderBottom: "1px solid #f5f5f5"
  },
  mb: {
    marginBottom: 30
  }
});

const CONSUMER = 2;
const VOLUNTEER = 1;

class AccountHome extends React.Component {
  state = {
    value: 0,
    searchQuery: ""
  };

  componentDidMount() {
    this.parseQueryString();
    this.props.fetchTests({page: 1});
    this.props.fetchTestsEnCurso({page: 1});
  }

  parseQueryString() {
    let queryString = this.props.location.search;
    if (queryString.search(/\?/gi) !== -1) {
      let result = queryString.match(/at=([0-9]+)/);
      try {
        this.setState({
          value: parseInt(result[1])
        });
      } catch (e) {}
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if(nextProps.location.search !== this.props.location.search) {
  //     this.parseQueryString();
  //     return true;
  //   }
  //   return true;
  //   //this.parseQueryString();
  // }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, theme, auth, tests, encurso } = this.props;
    console.log("tests", tests);
    console.log("theme", theme);

    return (
      <div className={classes.root}>
        <AppBar position="static" color="default" className={classes.appBar}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
          >
            <Tab label="TEST" />
            <Tab label="TEST EN CURSO" />
            {auth.account_type === VOLUNTEER && <Tab label="PAGOS" />}
          </Tabs>
        </AppBar>
        {this.state.value == 0 && (
          <TabContainer>
            {/*<SearchInput />*/}
            {!tests && <CircularProgress />}
            <Invitations tests={tests}/>
          </TabContainer>
        )}
        {this.state.value == 1 && (
          <TabContainer dir={theme.direction} padding={10}>
            {!encurso && <CircularProgress />}
            {encurso && <EnCursoInvs tests={encurso}/>}
          </TabContainer>
        )}
        {this.state.value == 2 && (
          <TabContainer dir={theme.direction}>
            <Typography paragraph variant="caption" align="center">
              No hay pagos todavía
            </Typography>
          </TabContainer>
        )}
      </div>
    );
  }
}

AccountHome.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default connect(
  state => ({
    auth: state.auth,
    tests: state.tests.tests,
    encurso: state.tests.encurso,
  }),
  { fetchTests, fetchTestsEnCurso }
)(withStyles(styles, { withTheme: true })(AccountHome));



// WEBPACK FOOTER //
// ./src/modules/account/components/AccountHome.js